(function () {
    'use strict';

    angular
        .module('initiativeUpdateStatusControllers')
        .directive('initiativeUpdateStatusOwnerCard', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                owner:              '=',
                readOnly:           '=',
                isMultiSelect:      '=',
                toSendReminder:     '&'
            },
            restrict: 'AE',
            templateUrl: require('./ownerCard.tpl.html'),
            controller: ['$scope', '$state', '$timeout', function ($scope, $state, $timeout) {

                // Reminder flags
                $scope.sendReminderError = null;
                $scope.sendReminderSuccess = false;
                $scope.sendingReminderInProgress = false;
                var sendReminderSuccessTimeout = null;

                // Show or hide actions
                $scope.card_onClick = function ($event) {
                    if ($scope.readOnly || $scope.isMultiSelect) return;
                    $scope.showOrHideActions($event);
                    $event.stopPropagation();
                };

                $scope.showOrHideActions = function ($event) {
                    if ($scope.readOnly || $scope.isMultiSelect) return;
                    $scope.displayActions = !$scope.displayActions;
                    $event.stopPropagation();
                };

                // Send reminder to owner
                $scope.sendReminderToOwner = function () {

                    $scope.sendReminderError = null;
                    $scope.sendReminderSuccess = null;
                    $scope.sendingReminderInProgress = true;
                    if (sendReminderSuccessTimeout !== null) {
                        $timeout.cancel(sendReminderSuccessTimeout);
                    }
                    sendReminderSuccessTimeout = null;
                    $scope.toSendReminder()
                        .then(function () {
                            $scope.sendReminderError = null;
                            $scope.sendReminderSuccess = true;
                            sendReminderSuccessTimeout = $timeout(function () {
                                $scope.sendReminderSuccess = false;
                                $scope.displayActions = false;
                            }, 1500);
                        })
                        .catch(function () {
                            $scope.sendReminderError = "The reminder couldn't be sent. Please try again later.";
                        })
                        .finally(function () {
                            $scope.sendingReminderInProgress = false;
                        });
                };

                // Show Send Reminder Action
                $scope.showSendReminderAction = function () {
                    var ownerStatusValue = $scope.owner.OwnerStatusValue;

                    if (ownerStatusValue === 'Completed') return false;

                    return true;
                };
            }], 
            link: function (scope, element, attrs) {
                //Display or not actions
                scope.displayActions = false;
            }
        };
    }
})();